import { Component, OnInit } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { NavController } from '@ionic/angular';
import { ModalController } from '@ionic/angular';
import { ModalPage } from '../modal/modal.page'
import { FormBuilder, Validators } from '@angular/forms';
import { PopoverController } from '@ionic/angular';
import { PopoverComponent } from '../popover/popover.component';
//import { myEnterAnimation } from '../animations/enter';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../config.service';
import { NavExtrasService } from '../data.service';
import { AnalyticsService } from '../analytics.service';

@Component({
  selector: 'app-address',
  templateUrl: './address.page.html',
  styleUrls: ['./address.page.scss'],
})
export class AddressPage implements OnInit {

  loading: Boolean = false;
  loadingText: String = 'Loading';
  physicalAddress: String = '';
  addressExists: Boolean = false;
  apiError: Boolean = false;
  outOfTopCity: Boolean = true;
  geocode_error: Boolean = false;
  headerBranding: String;
  apiKey: string;
  preventAddressSave: Boolean;
  captureEmail: Boolean;
  emailLink: String;
  captureBallotpediaEmail: Boolean;
  collectAnalytics: Boolean;
  clientName: String;
  isBallotpediaWebApp: Boolean;
  condensedInput: Boolean;

  errorMessages = {
    street: [
      { type: 'required', message: 'Street required' }
    ],
    city: [
      { type: 'required', message: 'City required' }
    ],
    state: [
      { type: 'required', message: 'State required' }
    ],
    zip: [
      { type: 'required', message: 'ZIP required' },
      { type: 'pattern', message: 'Please enter a valid ZIP code' }
    ]
  }

  addressForm = this.formBuilder.group({
    street: ['', [Validators.required]],
    city: ['', [Validators.required]],
    state: ['', [Validators.required]],
    zip: ['', [Validators.required, Validators.pattern('[0-9]{5}')]],
    email: ['', '']
  })


  addressFormCondensedInput = this.formBuilder.group({
    streetCondensedInput: ['', [Validators.required]],
    cityStateCondensedInput: ['', [Validators.required]],
    emailCondensedInput: ['', '']
  })

  errorMessagesCondensedInput = {
    streetCondensedInput: [
      { type: 'required', message: 'Street required' }
    ],
    cityStateCondensedInput: [
      { type: 'required', message: 'City and State required' }
    ]
  }

  constructor(
    private configService: ConfigService,
    private storage: Storage,
    private navController: NavController,
    private formBuilder: FormBuilder,
    public popoverController: PopoverController,
    public modalController: ModalController,
    public httpClient: HttpClient,
    public navExtrasService: NavExtrasService,
    public analyticsService: AnalyticsService

  ) { }

  get street() {
    return this.addressForm.get('street');
  }
  get city() {
    return this.addressForm.get('city');
  }
  get state() {
    return this.addressForm.get('state');
  }
  get zip() {
    return this.addressForm.get('zip');
  }
  get email() {
    return this.addressForm.get('email');
  }

  get streetCondensedInput() {
    return this.addressFormCondensedInput.get('streetCondensedInput');
  }

  get cityStateCondensedInput() {
    return this.addressFormCondensedInput.get('cityStateCondensedInput');
  }

  get emailCondensedInput() {
    return this.addressFormCondensedInput.get('emailCondensedInput');
  }


  async ngOnInit() {

    // Initiate Storage
    await this.storage.create();

    // Can talk to parent page to scroll to top upon load:
    
    // if (this.isBallotpediaWebApp) {
    //   const parent_origin = "https://ballotpedia.org";
    //   parent.postMessage({'task': 'scroll_top'}, parent_origin);
    // }
   

    console.log('*** No Local Cache 9/4 test ***')

    let res = await this.configService.getConfiguration();
    this.headerBranding = res["headerBranding"];
    this.apiKey = res["key"];
    this.preventAddressSave = res["preventAddressSave"];
    this.captureEmail = res["email"].capture;
    this.captureBallotpediaEmail = res["email"].captureBallotpediaEmail;
    this.emailLink = res["email"].link;
    this.collectAnalytics = res["collectAnalytics"];
    this.clientName = res["clientName"];
    this.isBallotpediaWebApp = res["isBallotpediaWebApp"];
    this.condensedInput = res["condensedInput"];

    if(!this.preventAddressSave) {
      this.addressExists = await this.storage.get('addressExists');

      if(this.addressExists) {
  
        let street = await this.storage.get('street');
        let city = await this.storage.get('city');
        let state = await this.storage.get('state');
        let zip = await this.storage.get('zip');
  
        if (street && city && state && zip) {
          this.addressForm.patchValue({
            street: street,
            city: city,
            state: state,
            zip: zip
        });
        }
      }
    }
  

  }

  submit() {


    if(this.collectAnalytics) {
      this.analyticsService.trackEvent('submit address');
    }


    if(this.condensedInput) {
      if (this.addressFormCondensedInput.valid) {
        this.saveAddress();
      } else {
        return;
      }
    } else {
      if(this.addressForm.valid) {
        this.saveAddress();
      } else {
        return;
      }
    }

  }


  // For Debugging
  async removeAllStorage() {
    await this.storage.clear();
    console.log('All storage cleared');
  }



  saveAddress = async () => {

    // // Temporary solution to help with iOS scroll
    // // Scroll to top of Parent page.
    // if (this.isBallotpediaWebApp) {
    //   const parent_origin = "https://ballotpedia.org";
    //   parent.postMessage({'task': 'scroll_top'}, parent_origin);
    // }
   
    this.loading = true;
    this.loadingText = 'Loading Elections';
    let geocode: any;
	  this.geocode_error = false;


  
    if(!this.preventAddressSave) {
      // If a new address is entered, we want to clear all old data:
      await this.storage.clear();
      console.log('All storage cleared');
    }


   
    // For Condensed Input for Ballotpedia:

    if (this.captureEmail && this.captureBallotpediaEmail && this.condensedInput) {

      // The subscribe email to Pardot has been moved to the elections component
      // so we can capture the lat/lng and districts and move that to Pardot as well.

      // try {
      //   fetch(`${this.emailLink}?email=${this.addressFormCondensedInput.value.emailCondensedInput}&address=${this.addressFormCondensedInput.value.streetCondensedInput} ${this.addressFormCondensedInput.value.cityStateCondensedInput}&MessageType[]=NewsletterList&campaign_id=20180`,
      //     {
      //       method: 'GET',
      //       headers: {}
      //     })
      //  } catch(e) {
      //    console.log(e);
      //  }

      this.navExtrasService.setEmailAddress(this.addressFormCondensedInput.value.emailCondensedInput);


       // Backup on site
       try {
        fetch(`https://ballotpedia.org/my_vote_engage_subscribe.php?email=${this.addressFormCondensedInput.value.emailCondensedInput}&client=My Vote (Ballotpedia)`,
          {
            method: 'GET',
            headers: {}
          })
       } catch(e) {
         console.log(e);
       }


    // For Regular long Inputs for Ballotpedia:
    } else if (this.captureEmail && this.captureBallotpediaEmail) {
      
      // The subscribe email to Pardot has been moved to the elections component
      // so we can capture the lat/lng and districts and move that to Pardot as well.
      
      // try {
      //   fetch(`${this.emailLink}?email=${this.addressForm.value.email}&address=${this.addressForm.value.street}&city=${this.addressForm.value.city}&state=${this.addressForm.value.state}&zip=${this.addressForm.value.zip}&MessageType[]=NewsletterList&campaign_id=20180`,
      //     {
      //       method: 'GET',
      //       headers: {}
      //     })
      //  } catch(e) {
      //    console.log(e);
      //  } 

      // Backup on site
      try {
        fetch(`https://ballotpedia.org/my_vote_engage_subscribe.php?email=${this.addressForm.value.email}&client=My Vote (Ballotpedia)`,
          {
            method: 'GET',
            headers: {}
          })
        } catch(e) {
          console.log(e);
        }


      // Otherwise if client version, send info only to our my_vote_subscription script endpoint:
    } else if(this.captureEmail) {
      console.log("EMAIL:");
      console.log(this.addressForm.value.email);

      try {
       await fetch(`${this.emailLink}?email=${this.addressForm.value.email}&client=${this.clientName}`,
         {
           method: 'GET',
           headers: {}
         })
      } catch(e) {
        console.log(e);
      }
    }




    try {

      let headers;

      if (this.apiKey) {
        headers = {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-api-key': this.apiKey
        }
      } else {
        headers = {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      }


      if(this.condensedInput) {

        // Encode hashes (#) in URL because this breaks the query params

        this.addressFormCondensedInput.value.streetCondensedInput = this.addressFormCondensedInput.value.streetCondensedInput.replace('#', '%23');

        geocode = await fetch(`https://api4.ballotpedia.org/geocode?location=${this.addressFormCondensedInput.value.streetCondensedInput} ${this.addressFormCondensedInput.value.cityStateCondensedInput}`,
        {
          method: 'GET',
          headers: headers
        })
      } else {
        geocode = await fetch(`https://api4.ballotpedia.org/geocode?location=${this.addressForm.value.street} ${this.addressForm.value.city} ${this.addressForm.value.state} ${this.addressForm.value.zip}`,
        {
          method: 'GET',
          headers: headers
        })
      }



   


      geocode = await geocode.json();

      if (!this.preventAddressSave) {
        await this.storage.set('addressExists', true);
        await this.storage.set('physicalAddress', `${this.addressForm.value.street} ${this.addressForm.value.city} ${this.addressForm.value.state} ${this.addressForm.value.zip}`);
        await this.storage.set('street', this.addressForm.value.street);
        await this.storage.set('city', this.addressForm.value.city);
        await this.storage.set('state', this.addressForm.value.state);
        await this.storage.set('zip', this.addressForm.value.zip);
        await this.storage.set('lat', geocode.data.geometry.location.lat);
        await this.storage.set('long', geocode.data.geometry.location.lng);
      } else {
        this.navExtrasService.setCoordinates(geocode.data.geometry.location.lat, geocode.data.geometry.location.lng);
        if (this.condensedInput) {
          this.navExtrasService.setStringAddress(`${this.addressFormCondensedInput.value.streetCondensedInput} ${this.addressFormCondensedInput.value.cityStateCondensedInput}`);
        } else {
          this.navExtrasService.setStringAddress(`${this.addressForm.value.street} ${this.addressForm.value.city} ${this.addressForm.value.state} ${this.addressForm.value.zip}`);
        }
        
      }

    } catch(e) {
      this.loading = false;
	    this.geocode_error = true;
	    this.openModal();
    } finally {
      this.loading = false;
      this.navController.navigateForward(`/elections`);
    }

  }
  async presentPopover(event: any) {
    const popover = await this.popoverController.create({
      component: PopoverComponent,
      componentProps: {
        message: `<p>Not registered to vote yet?</p><p>Just use the address where you will be registered.</p><p>You can also visit Ballotpedia.org for more voter registration information.</p>`,
          BpButtonLink: 'https://ballotpedia.org/Voter_registration',
          BpButtonText: this.isBallotpediaWebApp ? 'LEARN MORE' : 'GO TO BALLOTPEDIA'
      },
      event: event,
      translucent: true,
      backdropDismiss: true,
      showBackdrop: true,
      cssClass: 'popover'
    });
    return await popover.present();
  }

  async openModal( ) {
    const modal = await this.modalController.create({
      component: ModalPage,
      //enterAnimation: myEnterAnimation,

      componentProps: {
		    "geocode_error": true,
        "ballotmeasure": null,
        "candidateInfo": null,
        "raceInfo": null,
        "volunteerCandidate": null,
        "saved": false
       }
    });
    return await modal.present();
  }

}
